import {
  Container,
  Paper,
  Stack,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
  Avatar,
  SvgIcon,
} from "@mui/material";
import { Link } from "react-router-dom";
import { ReactComponent as FileIcon } from "../../@lib/icons/file-icon.svg";
import { ReactComponent as ArrowRightIcon } from "../../@lib/icons/chevron-right-icon.svg";
import { documentsDateConversion } from "../../utils/helpers";
import { ConditionalRenderer } from "../conditionalRenderer";
import { useLanguageTranslator } from "../useLanguageContext";
import { DataDisplayMessage } from "../dataDisplayMessage";

function LatestReport({
  items,
  path,
  isAllShow = true,
  subtitle = "",
  loading = false,
  isDashboard = false,
}: any) {
  const { translator } = useLanguageTranslator();
  return (
    <Container sx={{ my: 3 }}>
      <ConditionalRenderer condition={isAllShow}>
        <Paper component={Container} sx={{ py: 3, mb: 2 }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <ConditionalRenderer condition={!isDashboard}>
                <Typography variant="h4">
                  {translator("Latest Reports")}
                </Typography>
              </ConditionalRenderer>
              <ConditionalRenderer condition={isDashboard}>
                <Typography variant="h4" ml={3}>
                  {subtitle}
                </Typography>
              </ConditionalRenderer>
            </div>
            <Link
              to={path}
              style={{
                textDecoration: "none",
                color: "#757575",
              }}
            >
              {translator("View all")}
            </Link>
          </Stack>
        </Paper>
      </ConditionalRenderer>
      <DataDisplayMessage data={items} loading={loading} />
      <ConditionalRenderer condition={items?.length > 0}>
        <Paper>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{translator("dashboardTableHead.Name")}</TableCell>
                  <TableCell>
                    {translator("dashboardTableHead.Date Created")}
                  </TableCell>
                  <TableCell align="right">
                    {translator("dashboardTableHead.View")}
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {items?.map((elem: any, i: any) => {
                  const dateCreatedAt = documentsDateConversion(
                    elem?.createdAt
                  );
                  return (
                    <TableRow key={`${i}`}>
                      <TableCell>
                        <Box
                          sx={{ display: "inline-flex", alignItems: "center" }}
                        >
                          <Avatar sx={{ mr: 2 }}>
                            <SvgIcon component={FileIcon} inheritViewBox />
                          </Avatar>
                          <Typography variant="h6" whiteSpace="nowrap">
                            {elem?.filename?.slice(0, 50)}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>{dateCreatedAt}</TableCell>
                      <TableCell align="right">
                        <a
                          href={`https://niyel-tracker-api.aristarc-conseils.com${elem?.path}`}
                          target="blank"
                        >
                          <SvgIcon
                            href=""
                            target="blank"
                            component={ArrowRightIcon}
                            inheritViewBox
                          />
                        </a>
                      </TableCell>
                    </TableRow>
                  );
                })}

                {items?.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={2}>No Data</TableCell>
                    <TableCell />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </ConditionalRenderer>
    </Container>
  );
}
export { LatestReport };
